import React, { useState } from "react";
import PasswordGenerator from "./PasswordGenerator";
import { axiosInstance } from "../../axiosInstance";
import { notify } from "../../components/toastify";

import { useNavigate } from "react-router";

function AddSupervisor() {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handlePassword = (newPassword) => {
    setFormData((prevData) => ({ ...prevData, password: newPassword }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      const response = await axiosInstance.post(
        "/api/superadmin/supervisors/store",
        data
      );

      notify(response.data.message, "success");
      setTimeout(() => {
        navigate("/superadmin/manage");
      }, 2000);
    } catch (error) {
      notify(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        <h3 className="text-2xl font-semibold">Add New Company</h3>
        <p>Fill all input fields</p>
      </div>
      <form onSubmit={handleSubmit} className="p-6 bg-lightgray rounded-lg ">
        <h4 className="text-xl font-semibold mb-3 text-white">
          Company Details
        </h4>
        <div className="flex flex-col lg:flex-row gap-6 flex-wrap">
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none lg:w-[48%]"
            placeholder="First Name"
            type="text "
            name="firstname"
            // id="email"
            value={formData.firstname}
            onChange={handleChange}
            required
          />
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none lg:w-[48%]"
            placeholder="Last Name"
            type="text "
            name="lastname"
            // id="email"
            value={formData.lastname}
            onChange={handleChange}
            required
          />
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[48%]"
            placeholder="Youremail@mail.com"
            type="email"
            // id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <PasswordGenerator onPasswordChange={handlePassword} />
        </div>

        <div className="flex justify-center mt-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
          <button type="submit" className="w-full h-full" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddSupervisor;
